export const PREVIEW_DIMENSION = 226;
export const SIDES_PADDING = 24;

export const BOUNDARY_TERRITORY_LABEL_BACKGROUND_DEFAULT_COLOR = '#30839f';
export const BOUNDARY_TERRITORY_LABEL_TEXT_DEFAULT_COLOR = '#ffffff';
